// Weeks run Monday–Sunday in the viewer's own time zone. Dates are compared as
// YYYY-MM-DD strings, which sort correctly and never cross a UTC boundary the
// way Date objects do (a Monday evening in Brazil is already Tuesday in UTC).

const pad = (n: number) => String(n).padStart(2, '0');

export function ymd(d: Date): string {
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;
}

export function today(): string {
  return ymd(new Date());
}

/** The Monday on or before `d`. */
export function weekStartOf(d: Date = new Date()): string {
  const x = new Date(d.getFullYear(), d.getMonth(), d.getDate());
  const dow = (x.getDay() + 6) % 7; // Monday = 0
  x.setDate(x.getDate() - dow);
  return ymd(x);
}

export function parseYmd(s: string): Date {
  const [y, m, d] = s.split('-').map(Number);
  return new Date(y, m - 1, d);
}

export function addDays(s: string, n: number): string {
  const d = parseYmd(s);
  d.setDate(d.getDate() + n);
  return ymd(d);
}

export function weekLabel(weekStart: string): string {
  const start = parseYmd(weekStart);
  const end = parseYmd(addDays(weekStart, 6));
  const fmt = (d: Date) => d.toLocaleDateString(undefined, { month: 'short', day: 'numeric' });
  return `${fmt(start)} – ${fmt(end)}`;
}

export function shortDate(iso: string): string {
  const d = iso.length === 10 ? parseYmd(iso) : new Date(iso);
  return d.toLocaleDateString(undefined, { weekday: 'short', month: 'short', day: 'numeric' });
}

export function minutes(seconds: number): string {
  if (seconds < 60) return seconds > 0 ? '<1 min' : '0 min';
  const m = Math.round(seconds / 60);
  return m < 60 ? `${m} min` : `${Math.floor(m / 60)} h ${m % 60} min`;
}

/** The calendar date (YYYY-MM-DD) of an instant in a time zone — the class's "today". */
export function dayInZone(at: Date | string, tz: string | null | undefined): string {
  const d = typeof at === 'string' ? new Date(at) : at;
  try {
    return d.toLocaleDateString('en-CA', { timeZone: tz || undefined });
  } catch {
    return d.toLocaleDateString('en-CA');
  }
}
